import {array} from "../../../../../../wp-includes/js/dist/redux-routine";

export default function initRender() {
    document.addEventListener('DOMContentLoaded', () => {
        Site.init();
    });

    var Site = {
        init: function() {
            // Module List
            Site.headerHeight();
            Site.nav();
            Site.watchNavClickAway();
            Site.hoverButtons();
            Site.smoothScroll();
            Site.resourceCardTitles();
            Site.clearResults();
            Site.gsapLoad();
            Site.technicalForm();
            Site.subNavMobile();
            Site.ctaBlocks();
            Site.imageCorner();
            Site.teamCards();
            Site.megaMenuLock();

        },
        headerHeight: function() {
            function updateHeaderHeightVar() {
                const header = document.querySelector('.sticky-header');
                if (!header) return;
                // Don't update while mobile menu is open — avoids layout shift from scrollbar removal
                const menuOpen = !!document.querySelector('.wp-block-navigation__responsive-container.is-menu-open');
                if (menuOpen) return;

                let extra = 0;
                if (document.body.classList.contains('logged-in') && document.body.classList.contains('admin-bar')) {
                    extra = 40;
                }
                document.documentElement.style.setProperty(
                    '--optima-header-height',
                    `${header.offsetHeight + extra}px`
                );
            }

            window.addEventListener('load', updateHeaderHeightVar);
            window.addEventListener('resize', updateHeaderHeightVar);
            window.addEventListener('scroll', updateHeaderHeightVar);
        },
        nav: function() {
                //Forces the open menu to be a toggle for the closing of the menu
                const toggleButton = document.querySelector(
                    '.mobile-menu .wp-block-navigation__responsive-container-open'
                );
                if (!toggleButton) return;

                const navBlock = toggleButton.closest('.wp-block-navigation');
                const menuContainer = navBlock?.querySelector(
                    '.wp-block-navigation__responsive-container'
                );
                if (!menuContainer) return;

                const toggleMenuState = () => {
                    const isOpen = menuContainer.classList.contains('is-menu-open');

                    if (isOpen) {
                        // Close menu
                        toggleButton.classList.remove('wp-block-navigation__responsive-container-close');
                        toggleButton.setAttribute('aria-label', 'Open menu');
                        menuContainer.classList.remove('is-menu-open', 'is-modal-open');
                    } else {
                        // Open menu
                        toggleButton.classList.add('wp-block-navigation__responsive-container-close');
                        toggleButton.setAttribute('aria-label', 'Close menu');
                        menuContainer.classList.add('is-menu-open', 'is-modal-open');
                    }
                };

                toggleButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleMenuState();
                });

                toggleButton.addEventListener('touchstart', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleMenuState();
                }, { passive: false });

                // Optional: reposition menu on resize if needed
                window.addEventListener('resize', () => {
                    if (menuContainer.classList.contains('is-menu-open')) {
                        // reposition menu logic here
                    }
                });

        },
        watchNavClickAway: function() {
            const toggleButton = document.querySelector(
                '.wp-block-navigation__responsive-container-open'
            );
            if (!toggleButton) return;

            const navBlock = toggleButton.closest('.wp-block-navigation');
            if (!navBlock) return;

            const menuContainer = navBlock.querySelector(
                '.wp-block-navigation__responsive-container'
            );
            if (!menuContainer) return;

            const handleOutsideClick = (event) => {
                // Only act if menu is open
                if (!menuContainer.classList.contains('is-menu-open')) return;

                const clickedInsideNav = navBlock.contains(event.target);
                const clickedToggle = toggleButton.contains(event.target);

                // Ignore clicks inside nav or on toggle button
                if (clickedInsideNav || clickedToggle) return;

                // Close menu cleanly
                toggleButton.classList.remove(
                    'wp-block-navigation__responsive-container-close'
                );
                toggleButton.setAttribute('aria-label', 'Open menu');
                menuContainer.classList.remove('is-menu-open', 'is-modal-open');
            };

            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick, { passive: true });
        },
        hoverButtons: function (){
            const elements = document.querySelectorAll([
                '.wp-block-button[data-hover-background-color]',
                '.wp-block-group[data-hover-background-color]'
            ].join(','));

            elements.forEach((element) => {
                const hoverColor = element.dataset.hoverBackgroundColor;
                if (!hoverColor) return;

                // For buttons, we need to target the inner link
                // For groups, we target the element itself
                const target = element.classList.contains('wp-block-button')
                    ? element.querySelector('.wp-block-button__link')
                    : element;

                if (!target) return;

                // Store the original background color
                const original = target.style.backgroundColor || getComputedStyle(target).backgroundColor;

                // Add event listeners for hover
                target.addEventListener('mouseenter', (e) => {
                    // Prevent event from affecting parent groups
                    e.stopPropagation();
                    target.style.backgroundColor = hoverColor;
                });

                target.addEventListener('mouseleave', (e) => {
                    // Prevent event from affecting parent groups
                    e.stopPropagation();
                    target.style.backgroundColor = original;
                });
            });
        },
        smoothScroll: function () {
            // Smooth scrolling for anchor links
            const anchorLinks = document.querySelectorAll('a[href^="#"]');
            anchorLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    const href = this.getAttribute('href');
                    if (href === '#') return;

                    const target = document.querySelector(href);
                    if (target) {
                        e.preventDefault();
                        target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                });
            });
        },
        resourceCardTitles: function () {

            const newsTitles = document.querySelectorAll('.news-card .wp-block-post-title');

            function setEqualHeights() {
                let maxHeight = 0;

                // Reset heights first
                newsTitles.forEach(el => {
                    el.style.height = 'auto';
                });

                // Calculate tallest
                newsTitles.forEach(el => {
                    if (el.offsetHeight > maxHeight) {
                        maxHeight = el.offsetHeight;
                    }
                });

                // Apply height
                newsTitles.forEach(el => {
                    el.style.height = `${maxHeight}px`;
                });
            }

            // Run initially
            setEqualHeights();

            // Throttled resize (prevents chaos)
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(setEqualHeights, 100);
            });
        },
        clearResults: function () {
            //when .clear-results is clicked reload the page
            document.querySelectorAll('.clear-results').forEach(button => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    // Get the current URL
                    const url = new URL(window.location.href);
                    // Remove all query parameters
                    url.search = '';
                    // Reload the page with the clean URL
                    window.location.href = url.toString();
                });
            });

        },
        gsapLoad: function () {
            const _this = this;
            let scrollTimeout;

            // 1. The Animation Core (Idempotent)
            const initGSAP = () => {
                console.log("GSAP: Processing new elements...");
                gsap.registerPlugin(ScrollTrigger);

                // Select only elements that haven't been initialized yet
                const fadeElements = document.querySelectorAll('.gsap-fade-in:not(.gsap-init)');
                const fadeNoGrow = document.querySelectorAll('.gsap-fade-noGrow:not(.gsap-init)');

                // Fade In Logic
                fadeElements.forEach((el) => {
                    el.classList.add('gsap-init'); // Immediate flag to prevent double-processing
                    gsap.fromTo(el,
                        { opacity: 0, y: 40, scale: 0.96 },
                        {
                            opacity: 1, y: 0, scale: 1, duration: 1, ease: "power3.out",
                            scrollTrigger: { trigger: el, start: "top 85%", toggleActions: "play reverse play reverse" }
                        }
                    );
                });

                fadeNoGrow.forEach((el) => {
                    el.classList.add('gsap-init'); // Immediate flag to prevent double-processing
                    gsap.fromTo(el,
                        { opacity: 0, y: 40 },
                        {
                            opacity: 1, y: 0, scale: 1, duration: 1, ease: "power3.out",
                            scrollTrigger: { trigger: el, start: "top 85%", toggleActions: "play reverse play reverse" }
                        }
                    );
                });

                // Refresh ScrollTrigger positions once after DOM settles
                ScrollTrigger.refresh();
            };

            // 2. The Debouncer (Prevents the "Constant Loading" lag)
            const debounceInit = () => {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(initGSAP, 200); // Wait 200ms after last DOM change
            };

            // 3. Execution on Load
            if (document.readyState === "complete") {
                initGSAP();
            } else {
                window.addEventListener("load", initGSAP);
            }

            // 4. Smart AJAX/FSE Listeners
            // jQuery AJAX (Standard WP)
            if (window.jQuery) {
                jQuery(document).ajaxComplete(() => debounceInit());
            }

            // MutationObserver (FSE / Query Loop)
            // We only watch for 'childList' (added elements) to reduce CPU load
            const observer = new MutationObserver((mutations) => {
                const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
                if (hasNewNodes) {
                    debounceInit();
                }
            });

            const target = document.querySelector('.wp-site-blocks') || document.body;
            observer.observe(target, { childList: true, subtree: true });
        },
        technicalForm: function () {

            const fileBtn = document.querySelector('.gform_button_select_files');

            if (fileBtn) {
                fileBtn.textContent = 'Upload file';
            }

            const form = document.querySelector('#gform_1');
            if (!form) return;

            console.log('Services Form Found');

            const select = form.querySelector('.services-select select');
            if (!select) return;

            // safer slug extraction
            const pathParts = window.location.pathname.split('/').filter(Boolean);
            const slug = pathParts[1]; // ['service', 'chosen-service']

            if (!slug) return;

            const option = select.querySelector(`option[value="${slug}"]`);

            if (option) {
                option.selected = true;
            } else {
                console.warn('No matching option for slug:', slug);
            }

        },
        subNavMobile: function () {
            const items = document.querySelectorAll('.header-wrapper ul.wp-block-navigation li.has-child');
            const wrapper = document.querySelector('html');

            document.addEventListener('click', function (e) {
                const closeBtn = e.target.closest('.wp-block-navigation__responsive-container-close');

                if (!closeBtn) return;

                console.log('close button clicked tom!');

                setTimeout(() => {
                    document.documentElement.classList.remove('has-modal-open');
                    wrapper.classList.remove('has-modal-open');
                }, 100);

            }, true);

            items.forEach(function (item) {
                const subNav = item.querySelector('.wp-block-navigation__submenu-container');
                const button = item.querySelector('button');

                if (!subNav || !button) return;

                // set default state
                button.setAttribute('aria-expanded', 'false');

                item.addEventListener('click', function (e) {
                    if (window.innerWidth >= 1000) return;

                    const isExpanded = button.getAttribute('aria-expanded') === 'true';

                    items.forEach(function (otherItem) {
                        const otherBtn = otherItem.querySelector('button');
                        if (otherBtn) {
                            otherBtn.setAttribute('aria-expanded', 'false');
                        }
                        otherItem.classList.remove('is-open');
                        otherItem.classList.remove('is-open');
                    });

                    if (!isExpanded) {
                        button.setAttribute('aria-expanded', 'true');
                        item.classList.add('is-open');
                    }
                });
            });
        },
        ctaBlocks: function () {
            console.log('CTA Block loaded');

            const blocks = document.querySelectorAll('.cta-block');

            function updateBackgrounds() {
                const isMobile = window.innerWidth <= 782;

                blocks.forEach(el => {
                    const img = el.querySelector('.cta-block__image img');
                    const imgMobile = el.querySelector('.cta-block__image-mobile img');
                    const background = el.querySelector('.cta-block__background');

                    if (!background) return;

                    let src = '';

                    if (isMobile && imgMobile) {
                        src = imgMobile.currentSrc || imgMobile.src;
                    } else if (img) {
                        src = img.currentSrc || img.src;
                    }

                    if (src) {
                        background.style.backgroundImage = `url(${src})`;
                    } else {
                        background.style.backgroundImage = '';
                    }
                });
            }

            // Run on load
            updateBackgrounds();

            // Run on resize (with a tiny debounce so it doesn't go wild)
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(updateBackgrounds, 150);
            });
        },
        imageCorner: function () {
            const img = document.querySelectorAll('.image-corners');

            img.forEach(el => {
                const parent = el.closest('.opt-section');

                if (!parent) return;

                const parentStyles = window.getComputedStyle(parent);
                const parentBg = parentStyles.backgroundColor;

                el.style.borderTopColor = parentBg;
                el.style.borderBottomColor = parentBg;
            });
        },
        teamCards: function () {
            const teamCard = document.querySelectorAll('li.type-team');

            teamCard.forEach(card => {
                const email = card.querySelector('.team-block__email span').textContent;
                const link = card.querySelector('.optima-post-link-overlay');

                link.href = `mailto:${email}`;

            });
        },
        megaMenuLock: function () {
            console.log('Mega Menu Locked');

            const html = document.documentElement;

            document.addEventListener('click', function () {
                const mobileMenu = document.querySelector('.wp-block-outermost-mega-menu__toggle');

                if (!mobileMenu) return;

                const isExpanded = mobileMenu.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    html.style.overflow = 'hidden';
                } else {
                    html.style.overflow = '';
                }
            });
        }
    }
};